module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-03 2.d4f05f0e.png";